export default __webpack_public_path__ + "static/16-79f67c60ad349eddf581751ebc6c3c86.jpg";